import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';

@Service()
export default class MessageTemplateRenewalService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async GetRenewalCandidates(requestIds: string[]): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/message-template/renewal-candidates';
            const result = await this.axiosService.axiosInstance.post(url, { requestIds });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async GetCandidatesBySender(senderId: string, extendDuration: number): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/message-template/renewal-candidates-by-sender';
            const result = await this.axiosService.axiosInstance.post(url, { senderId, extendDuration });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async Renew(requestIds: string[], fromSenderExtension: boolean = false): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/message-template/renew';
            const result = await this.axiosService.axiosInstance.post(url, { requestIds, fromSenderExtension });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
}
